import { z } from 'zod';

// Migración desde OneDrive (spec 2026-10-14 §2): filas del Excel en el contrato del
// motor (POST /api/v1/quality/master-list/import/validate|commit) y su respuesta.

export interface ImportRowInput {
  areaPath: string[];
  areaNames?: string[];
  documentTypeCode: string;
  documentTypeName?: string;
  reviewFrequencyDays?: number;
  code: string;
  title?: string;
  origin?: string;
  status?: string;
  currentVersion: number;
  revisionLabel?: string;
  effectiveDate?: string;
  approvedAt?: string;
  reviewFrequencyDaysOverride?: number;
  norms?: { normCode: string; clause: string }[];
  ownerEmail?: string;
  responsibilities?: ({ role: string } & ({ email: string } | { positionCode: string }))[];
}

/** Problema de lectura del archivo, antes de ir al servidor. */
export interface SheetProblem {
  /** Fila del Excel (1 = encabezados); null = de toda la hoja. */
  row: number | null;
  column: string | null;
  message: string;
}

const issueSchema = z.object({
  level: z.enum(['error', 'warning']),
  reason: z.string(),
  field: z.string().optional(),
});

export const importPlanSchema = z.object({
  summary: z.object({
    totalRows: z.number(),
    ok: z.number(),
    errors: z.number(),
    warnings: z.number(),
    areasToCreate: z.number(),
    typesToCreate: z.number(),
    entriesToCreate: z.number(),
  }),
  taxonomyToCreate: z.object({
    areas: z.array(z.object({ path: z.array(z.string()), name: z.string() })),
    types: z.array(
      z.object({ code: z.string(), name: z.string(), reviewFrequencyDays: z.number() }),
    ),
  }),
  rows: z.array(
    z.object({
      index: z.number(),
      code: z.string(),
      status: z.enum(['ok', 'error', 'warning']),
      issues: z.array(issueSchema),
    }),
  ),
});
export type ImportPlan = z.infer<typeof importPlanSchema>;

export const validateResponseSchema = z.object({
  success: z.literal(true),
  data: importPlanSchema,
});

export const commitResponseSchema = z.object({
  success: z.literal(true),
  data: z.object({
    plan: importPlanSchema,
    counts: z.object({
      areasCreated: z.number(),
      typesCreated: z.number(),
      entriesCreated: z.number(),
    }),
    // Lote ya importado (mismo archivo): el servidor no escribió nada ahora.
    replayed: z.boolean().default(false),
    importedAt: z.string().optional(),
  }),
});
export type CommitResult = z.infer<typeof commitResponseSchema>['data'];
